import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import linkListService from './gettingLinkListService';

// Get user from
const initialState = {
  getLinkList: [],
  linkListError: false,
  linkListSuccess: false,
  linkListLoading: false,
  linkListErrorMsg: '',
  deteteAllLink: {
    deleteAllLinkSuccess: false,
    deleteAllLinkError: false,
    deleteAllLinkLoading: false,
    deleteAllLinkErrorMsg: false,
    deletedAllLinkState: '',
  },
};

// creating____________bioLink____________________
export const gettingLinkList = createAsyncThunk('linkList/gettingLinkList', async (linkListData, thunkAPI) => {
  try {
    return await linkListService.gettingLinkList(linkListData);
  } catch (error) {
    // handle all error like with status code 404 or 500 or 300 , not under 200
    const linkListErrorMsg =
      (error.response && error.response.data && error.response.data.linkListErrorMsg) ||
      error.linkListErrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(linkListErrorMsg);
  }
});
// ______________delete_________ALL LInk__________
export const deletingAllBlock = createAsyncThunk('deleteAllLink/deletingAllBlock', async (data, thunkAPI) => {
  try {
    return await linkListService.deletingAllBlock(data);
  } catch (error) {
    // handle all error like with status code 404 or 500 or 300 , not under 200
    const deleteAllLinkErrorMsg =
      (error.response && error.response.data && error.response.data.deleteAllLinkErrorMsg) ||
      error.deleteAllLinkErrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(deleteAllLinkErrorMsg);
  }
});
export const linkListSlice = createSlice({
  // handle the api response(promise coming from api) , either
  name: 'linkList',
  initialState,
  reducers: {
    resetLinkList: (state) => {
      state.linkListLoading = false;
      state.linkListSuccess = false;
      state.linkListError = false;
      state.linkListErrorMsg = '';
      state.gettingLinkList = [];
    },

    resetDeleteAllLinkSttae: (state) => {
      state.deteteAllLink.deleteAllLinkSuccess = false;
      state.deteteAllLink.deleteAllLinkError = false;
      state.deteteAllLink.deleteAllLinkLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettingLinkList.pending, (state) => {
        state.linkListLoading = true;
      })
      .addCase(gettingLinkList.fulfilled, (state, action) => {
        state.linkListLoading = false;
        state.linkListSuccess = true;
        state.getLinkList = action.payload;
      })
      .addCase(gettingLinkList.rejected, (state, action) => {
        state.linkListLoading = false;
        state.linkListError = true;
        state.linkListErrorMsg = action.payload; // error from catch will come here via action.payload and update linkListErrorMsg
      })

      // ____________deleting____________All link list _____________
      .addCase(deletingAllBlock.pending, (state) => {
        state.deteteAllLink.deleteAllLinkLoading = true;
      })
      .addCase(deletingAllBlock.fulfilled, (state, action) => {
        state.deteteAllLink.deleteAllLinkLoading = false;
        state.deteteAllLink.deleteAllLinkSuccess = true;
        state.deteteAllLink.deletedAllLinkState = action.payload;
        state.getLinkList = [];
      })
      .addCase(deletingAllBlock.rejected, (state, action) => {
        state.deteteAllLink.deleteAllLinkLoading = true;
        state.deteteAllLink.deleteAllLinkError = true;
        state.deteteAllLink.deleteAllLinkErrorMsg = action.payload; // error from catch will come here via action.payload and update linkListErrorMsg
      });
  },
});

export const { resetLinkList, resetDeleteAllLinkSttae } = linkListSlice.actions;
export default linkListSlice.reducer;
